<div class="create-blank-project-container">
  <app-dynamic-form
    [jsonSchema]="formSchema"
    [layout]="'horizontal'"
    [submitLabel]="'Create'"
    [resetLabel]="'Cancel'"
    [showActions]="false"
    (formSubmit)="onFormSubmit($event)">
  </app-dynamic-form>

  <div *ngIf="isSubmitting" class="loading-overlay">
    <div class="spinner"></div>
    <p>Creating project...</p>
  </div>
</div>

